
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 3C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H5.25V15V14.25H6H13.316C14.4156 12.8783 16.1052 12 18 12C19.0929 12 20.1175 12.2922 21 12.8027V8.41421C21 8.149 20.8946 7.89464 20.7071 7.70711L16.2929 3.29289C16.1054 3.10536 15.851 3 15.5858 3H13.75V6V6.75H13H6H5.25V6V3H4ZM6.75 15.75H12.4361C12.1549 16.4448 12 17.2043 12 18C12 19.0929 12.2922 20.1175 12.8027 21H6.75V15.75ZM6.75 3V5.25H9.25V3H6.75ZM10.75 3V5.25H12.25V3H10.75ZM14 18.9064L16.779 21.6854L22 16.4644L20.849 15.3134L16.779 19.3834L15.151 17.7554L14 18.9064Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowCacheFetchFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
